var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HostInfo',{attrs:{"pMainRoute":"/active-host"}})
}
var staticRenderFns = []

export { render, staticRenderFns }